import { Tabs } from "@material-ui/core";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { ListTransaksi, ListTransaksiLoading } from "./parts/ListPanel";
import history from "../../History/History";
import { StyledTab } from "../../components/CustomStyles/CustomTabs";
import { showWidthdrawInfo } from "./parts/WithdrawInfoDialog";
import { formatCurrency } from "../../components/Utils/Currency";
import { css, cx } from "emotion";
import InvoiceService from "../../Services/InvoiceService";
import { handleError } from "../../components/Utils/Utils";
import InvoiceStore from "../../Store/InvoiceStore";
import { Skeleton } from "@material-ui/lab";
import TenantStore from "../../Store/TenantStore";
import DateRangePickerFilter from "../../components/Filters/DateRangePicker";
import moment from "moment-timezone";

const Saldo = (props) => {
  const [tabActive, setTabActive] = React.useState(0);
  const prevTabActive = usePreviousTab(tabActive);
  const [invoiceState, invoiceActions] = InvoiceStore();
  const [tenantState, tenantActions] = TenantStore();
  const [bank, setBank] = React.useState({});

  let today = moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
  let tStart = moment(new Date().setMonth(-1)).tz("UTC").format();
  let tEnd = moment(today).tz("UTC").format();
  const [dateRange, setDateRange] = React.useState({
    startDate: tStart,
    endDate: tEnd,
    key: "",
  });

  let arrProcess = [
    {
      status: "all",
      label: "Semua",
    },
    {
      status: "credit",
      label: "Dana Masuk",
    },
    {
      status: "debit",
      label: "Dana Keluar",
    },
  ];
  let perPage = 20;

  function usePreviousTab(value) {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  }

  const handleTabChange = (event, newTab) => {
    setTabActive(newTab);
  };

  const onClickWidthdrowInfo = () => {
    showWidthdrawInfo();
  };

  const getTotalSaldo = () => {
    invoiceActions.getTotalSaldo();
  };

  const getBankName = (code) => {
    InvoiceService.getListBank()
      .then((response) => {
        let filteredData = response.filter((row) => {
          return row.bank_code === code;
        });

        setBank(filteredData[0]);
        return filteredData[0]?.bank_name;
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const getDetailTenant = () => {
    const user = JSON.parse(localStorage.getItem("user"));

    tenantActions
      .getByID(user?.tenant?.id)
      .then((response) => {
        if (response.bank_account_number !== "") {
          getBankName(response.bank_code);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getInvoiceHistoryList = (refresh, actionStatus) => {
    let status = actionStatus
      ? actionStatus
      : tabActive
      ? arrProcess[tabActive]["status"]
      : "all";
    const params = {
      status: status === "all" ? "" : status,
      num: perPage,
      cursor: !perPage
        ? ""
        : refresh === false && tabActive === prevTabActive
        ? invoiceState.header["x-cursor"]
        : "",
      trx_date_start: dateRange.startDate,
      trx_date_end: dateRange.endDate,
    };
    const isRefresh =
      refresh === false && tabActive === prevTabActive ? true : false;
    invoiceActions.getInvoiceHistoryList(params, isRefresh);
  };

  const handleDateChange = (val) => {
    let endDate = moment(val.endDate).format("YYYY-MM-DD") + " 23:59:59";
    let tStart = moment(val.startDate).tz("UTC").format();
    let tEnd = moment(endDate).tz("UTC").format();
    setDateRange({
      startDate: tStart,
      endDate: tEnd,
      key: val.key,
    });
  };

  React.useEffect(() => {
    const initialLoad = () => {
      getTotalSaldo();
      getDetailTenant();
    };

    initialLoad();
  }, []);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      getInvoiceHistoryList(true, arrProcess[tabActive].status);
    }, 500);

    return () => clearTimeout(timeout);
  }, [tabActive, dateRange]);

  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-lg-3 col-md-12 col-xs-12">
          <div
            className={cx(
              css`
                border-radius: 8px !important;
                padding: 20px !important;
              `,
              "card card-body border-0"
            )}
          >
            <span className="d-block font-16 font-bold text-primary">
              Total saldo aktif
            </span>
            {invoiceState?.isLoading && (
              <h4
                className={cx(
                  css`
                    color: #4caf50;
                  `,
                  "font-20 font-bold"
                )}
              >
                <Skeleton animation="wave" variant="text" />
              </h4>
            )}
            {!invoiceState?.isLoading && (
              <h4
                className={cx(
                  css`
                    color: #4caf50;
                  `,
                  "font-20 font-bold"
                )}
              >
                {formatCurrency(
                  process.env.REACT_APP_CURRENCY_CODE,
                  (invoiceState?.saldo?.total_amount || 0).toString()
                )}
              </h4>
            )}
            <div className="w-100 d-flex justify-content-between align-items-center mt-2">
              <button
                type="button"
                className={cx(
                  css`
                    border: none !important;
                    padding: 11px 17px !important;
                    border-radius: 8px !important;
                    font-size: 8px !important;
                    background-color: #2196f3 !important;
                  `,
                  "btn btn-info"
                )}
                onClick={() => {
                  history.push("/saldosaya/withdraw", {updateNav: false});
                }}
              >
                Tarik Saldo
              </button>
              <button
                type="button"
                className={cx(
                  css`
                    border: none !important;
                    padding: 11px 17px !important;
                    border-radius: 8px !important;
                    font-size: 8px !important;
                    background-color: #ffffff !important;
                    color: #2196f3 !important;
                  `,
                  "btn btn-info"
                )}
                onClick={() => {
                  onClickWidthdrowInfo();
                }}
              >
                Info Penarikan
              </button>
            </div>
          </div>
          <div
            className={cx(
              css`
                border-radius: 8px !important;
                padding: 20px !important;
              `,
              "card card-body border-0 mt-3"
            )}
          >
            <span className="d-block font-16 font-bold text-primary">
              Nomor Rekening
            </span>
            <div>
              {tenantState?.isLoading && (
                <p className="font-14 text-primary">
                  <Skeleton variant="text" animation="wave" />
                </p>
              )}

              {!tenantState?.isLoading &&
                tenantState?.tenant?.bank_account_number !== "" && (
                  <p className="font-14 font-bold text-primary">
                    {` ${bank.bank_name} | ${tenantState?.tenant?.bank_account_number} | ${tenantState?.tenant?.bank_account_name}`}
                  </p>
                )}

              {!tenantState?.isLoading &&
                tenantState?.tenant?.bank_account_number === "" && (
                  <p className="font-14 font-bold text-danger">
                    {`Silahkan Menghubungi Pihak Mall ${tenantState?.tenant?.property?.name} Untuk Memasukkan Rekening`}
                  </p>
                )}
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-12 col-xs-12">
          <div
            className={cx(
              css`
                border-radius: 8px !important;
                padding: 0px !important;
                padding-bottom: 20px !important;

                @media (max-width: 768px) {
                  margin-top: 1em !important;
                }
              `,
              "card card-body border-0"
            )}
          >
            <span
              className={cx(
                css`
                  padding: 20px !important;
                `,
                "d-block font-16 font-bold text-primar"
              )}
            >
              Transaksi Terakhir
            </span>
            <div
              className={cx(
                css`
                  display: flex !important;
                  padding-right: 1rem !important;
                  border-bottom: 2px solid #eeeeee !important;
                  @media (max-width: 768px) {
                    display: block !important;
                    padding-right: 0px !important;
                    border-bottom: none !important;
                  }
                `,
                "w-100 justify-content-between align-items-center mb-3"
              )}
            >
              <Tabs
                value={tabActive}
                onChange={handleTabChange}
                variant="scrollable"
                className={cx(css`
                  @media (max-width: 768px) {
                    border-bottom: 2px solid #eeeeee !important;
                  }
                `)}
              >
                {arrProcess.map((process, index) => {
                  return (
                    <StyledTab
                      key={index}
                      label={process.label}
                      className={cx(
                        css`
                          height: 70px !important;
                        `
                      )}
                    ></StyledTab>
                  );
                })}
              </Tabs>
              <div
                className={cx(
                  css`
                    @media (max-width: 576px) {
                      padding: 4px !important;
                      margin-top: 1em !important;
                    }

                    @media (max-width: 768px) {
                      padding: 8px;
                      margin-top: 1em !important;
                    }
                  `,
                  "d-flex flex-wrap flex-lg-nowrap justify-content-end align-items-center"
                )}
              >
                {/* <ButtonExport /> */}
                <DateRangePickerFilter
                  onChange={(val) => handleDateChange(val)}
                  defaultDate={dateRange}
                  maxDate={new Date()}
                />
              </div>
            </div>
            <div className={cx(css`max-height: 600px !important; overflow-y: scroll`,"px-3")}>
              <div
                className={cx(css`
                  overflow-x: scroll !important;
                `)}
              >
                <div
                  className={cx(css`
                    min-width: 650px !important;
                  `)}
                >
                  {invoiceState?.historys.length > 0 &&
                    invoiceState?.historys.map((value, key) => {
                      return <ListTransaksi id={key} key={key} data={value} />;
                    })}
                  {invoiceState?.isLoadingHistory &&
                    Array.from(new Array(10)).map((value, key) => {
                      return <ListTransaksiLoading key={key} id={key} />;
                    })}
                </div>
              </div>
              {!invoiceState.isLoadingHistory &&
                invoiceState.historys.length === 0 && (
                  <div className="p-2 text-center">
                    <span className="font-12 text-muted">No History Data</span>
                  </div>
                )}
              {invoiceState.historys.length >= perPage - 1 &&
                perPage !== false && (
                  <div className="p-2 text-center">
                    {invoiceState.lastPage ? (
                      <h2>~</h2>
                    ) : (
                      <button
                        className="btn btn-sm btn-outline-dark"
                        onClick={() => getInvoiceHistoryList(false)}
                        disabled={invoiceState.isLoadingHistory}
                      >
                        {invoiceState.isLoadingHistory
                          ? "Please Wait"
                          : "Load More"}
                      </button>
                    )}
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Saldo;
